module.exports = __webpack_public_path__ + "static/media/tipologia12.8d3d4fdc.png";